export default {
    data() {
        return {
            backText: window.Drupal.t('Back'),
            googleInsideText: window.Drupal.t('Take a look inside'),
            planRouteText: window.Drupal.t('Plan route'),
            openingTimesText: window.Drupal.t('Opening times'),
            openText: window.Drupal.t('Open'),
            closedText: window.Drupal.t('Closed'),
            untilText: window.Drupal.t('Until'),
            finderPlaceholder: window.Drupal.t('Search by city or postal code'),
            resetMapText: window.Drupal.t('Reset map'),
            listViewText: window.Drupal.t('List view'),
            mapViewText: window.Drupal.t('Map view'),
            branchesText: window.Drupal.t('branches'),
            branchesNearText: window.Drupal.t('near you'),
            loadingText: window.Drupal.t('loading..'),
            findABranchText: window.Drupal.t('Find a branch'),
            newPageTitleText: window.Drupal.t('Branches | PartsPoint'),
        }
    }
}